import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomepageComponent } from './homepage.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/_global/_shared.module';
import { BookingService } from '../booking/booking.service';
import { RegUnitsResolver } from '../booking/_resolvers/reg-units.resolver';

const routes: Routes = [
    {
        path: '',
        component: HomepageComponent,
        resolve: {
            regUnits: RegUnitsResolver,
        },
    },
];

@NgModule({
    declarations: [HomepageComponent],
    imports: [CommonModule, RouterModule.forChild(routes), SharedModule],
    exports: [RouterModule],
})
export class HomepageModule {}
